import {
  IonButton,
  IonCol,
  IonGrid,
  IonImg,
  IonRow,
  IonText,
} from "@ionic/react";
import { FUNCTIONALITY_COMING_SOON } from "../../../utils/constants";
import { ToastMessage } from "../../../utils/ToastMessage";
import React, { useState } from "react";
import "./toggleButton.scss";

export interface IToggle {
  handleChange: Function;
  isMapActive?: boolean;
}

const ToggleButton = (props: IToggle) => {
  const { handleChange, isMapActive = false } = props;
  const [active, setActive] = useState("list");

  const handleClick = (type: string) => {
    if (type === "map" && !isMapActive) {
      ToastMessage.show(FUNCTIONALITY_COMING_SOON);
      return true;
    }
    setActive(type);
    handleChange(type);
  };

  return (
    <IonGrid className="toggle-btn-wrapper">
      <IonRow>
        <IonCol>
          <IonButton
            mode="ios"
            className={`toggle-btn ${active === "list" ? "active" : ""}`}
            data-testid="listToggle"
            onClick={() => handleClick("list")}
          >
            <IonImg src="assets/icon/list-icon.svg"></IonImg>
            <IonText>List</IonText>
          </IonButton>
        </IonCol>
        <IonCol>
          <IonButton
            className={`toggle-btn ${active === "map" ? "active" : ""}`}
            onClick={() => handleClick("map")}
          >
            <IonImg src="assets/icon/map-icon.svg"></IonImg>
            <IonText>Map</IonText>
          </IonButton>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default ToggleButton;
